/**
 * ╔════════════════════════════════════════════════════════════╗
 * ║  VERIFICATION CORE PHILOSOPHY                              ║
 * ╠════════════════════════════════════════════════════════════╣
 * ║  Core Philosophy of Verification: Execution-Based Quality Assurance ║
 * ╚════════════════════════════════════════════════════════════╝
 */

export const VERIFICATION_CORE = `
# Verification Phase Philosophy

Verify through actual execution:
1. Build the project
2. Run tests
3. Check linting and type errors
4. Validate runtime behavior

Real execution is the ultimate verification.
`;
